import ApiBuilder from '../helpers/ApiBuilder';

const getAllUserCompanies = () => {
  return ApiBuilder.API.get('/api/init/companies');
};

export default {
  getAllUserCompanies,
};
